<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"Kitchen" | translate}} </h5>
        <div class="edit-icons">
            <i class="material-icons" (click)="onCloseDilog()">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column">
        <div class="header border-b-i d-flex align-items-center flex-wrap gap-2 pt-4 pb-4">
            <div class="d-flex flex-wrap" style="gap: 10px 0px">
                <div class="search-cont">
                    <div class="s-in form-input" style="position: relative">
                        <mat-icon class="input-icon">search</mat-icon>
                        <input type="text" placeholder="Search" class="form-control" />
                    </div>
                    <div class="go-b">
                        {{ "COMMON.GO" | translate }}
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-column">
            <mat-expansion-panel *ngFor="let data of listArr; let i = index" class="mt-3 height-55" expanded="true"
                (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="d-flex flex-column">
                            <div class="mt-1">{{data.st_ti}} - {{data.ed_ti}} - {{data.j_c}} </div>
                            <div class="hidden-t">{{data.add}} </div>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                        <i class="material-icons cursor-pointer" (click)="onEdit(data,'normal')">edit</i>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="inner-container">
                    <div class="row">
                        <div class="col-12 col-md-5  ">
                            <div class="inner-header p-3 border-b-c d-flex align-items-center justify-content-between">
                                {{data.available.length}} Available
                                <i *ngIf="data.available.length != 0" class="material-icons cursor-pointer"
                                    [matMenuTriggerFor]="menu">more_vert</i>

                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item color="warn" (click)="acceptAll(data.id)" type="button">
                                        <span>{{'Accept All' | translate}}</span>
                                    </button>
                                </mat-menu>

                            </div>
                            <div class="inner-body">
                                <div class="det-div d-flex justify-content-between gap-2"
                                    *ngFor="let avaData of data.available">
                                    <div class="user-d d-flex align-items-center gap-1" (click)="onViewEmployee(avaData.em_i)">

                                        <img class="user-p" *ngIf="avaData.profile_picture"
                                            [src]="avaData.profile_picture" alt="">
                                        <img class="user-p" *ngIf="!avaData.profile_picture"
                                            src="assets/images/icons/employee.png" alt="">

                                        <div class="">
                                            <div class="title">{{avaData.first_name}} {{avaData.last_name}}</div>
                                            <div class="sub-title">{{avaData.email}}</div>
                                        </div>
                                    </div>
                                    <div class="btn btn-outline-primary"
                                        (click)="onConfirmationModal(avaData,1,data.id)">
                                        Book</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-7 ">
                            <div class="inner-header p-3 border-b-c d-flex align-items-center justify-content-between">
                                {{data.book.length}} Booked / <div class="me-auto"> {{ data.qty }} Needed</div>
                                <!-- <div class="d-flex gap-1">
                                    <i class="material-icons cursor-pointer"
                                        [matMenuTriggerFor]="menu2">more_vert</i>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item color="warn"  type="button">
                                            <span>{{'Reject All' | translate}}</span>
                                        </button>
                                    </mat-menu>
                                </div> -->
                            </div>
                            <div class="inner-body">
                                <div class="det-div det-bg-green d-flex justify-content-between gap-2"
                                    *ngFor="let bookData of data.book" >
                                    <div class="user-d d-flex align-items-center gap-1" (click)="onViewEmployee(bookData.em_i)">
                                        <img class="user-p" *ngIf="bookData.profile_picture"
                                            [src]="bookData.profile_picture" alt="">
                                        <img class="user-p" *ngIf="!bookData.profile_picture"
                                            src="assets/images/icons/employee.png" alt="">

                                        <div class="">
                                            <div class="title">{{bookData.first_name}} {{bookData.last_name}}</div>
                                            <div class="sub-title">{{bookData.email}}</div>
                                        </div>
                                    </div>
                                    <div class="btn btn-outline-primary"
                                        (click)="onConfirmationModal(bookData,0,data.id)">
                                        Unbook</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </div>
</div>